function setOutstandingReports(data) {
	return {
		type: 'SET_OUTSTANDING_REPORTS',
		payload: data,
	};
}

export { setOutstandingReports };
